<template>
<div class="page">
  <Header title="解决方案" />
<div>
    <div class="solution-item container themecolor" v-if="id == 1">
        <h1 class="solution-title themecolor">忘记用户名、密码</h1>
        <p>请点击登陆界面下方的‘忘记密码’，只要正确填写您注册的公司名称及负责人手机号，就可以通过该手机号码获得临时登陆密码，请在成功登陆后修改该密码。或者您可以致电博世公司（400-000-5109服务热线），索取您的用户名和密码。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 2">
        <h1 class="solution-title themecolor">修改密码</h1>
        <p> 用户可在我的设置中点击密码修改，进入修改密码页面，再依次输入“旧密码，新密码，确认新密码“，即可完成密码修改。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 3">
        <h1 class="solution-title themecolor">修改信息</h1>
        <p>倘若贵公司的信息，发生变更或需要更改时，请进入资料修改界面，自助提交修改内容，但自助可修改的信息不包括公司名称，客户编号及负责人和他的手机号。如果需要修改公司名称，负责人及负责人手机号，请再次提交申请表。您也可致电易加网客户服务中心400-000-5109咨询具体操作。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 4">
        <h1 class="solution-title themecolor">积分获取途径</h1>
        <div class="clearfix integration-gain-wrapper">
            <div class="pull-left integration-gain-l">经销商客户：</div>
            <div class="pull-left integration-gain-r">
                <ul>
                    <li>1. 采购博世正品配件</li>
                    <li>2. 参加产品促销</li>
                    <li>3. 参加易加网线上活动</li>
                </ul>
            </div>
        </div>
        <div class="clearfix integration-gain-wrapper">
            <div class="pull-left integration-gain-l">批发商客户：</div>
            <div class="pull-left integration-gain-r">
                <ul>
                    <li>1. 依照每年渠道政策得到积分奖励，渠道政策详情请咨询相关博世销售同事</li>
                    <li>2. 参加产品促销</li>
                    <li>3. 参加易加网线上活动（签到，抽奖等）</li>
                </ul>
            </div>
        </div>
        <div class="clearfix integration-gain-wrapper">
            <div class="pull-left integration-gain-l">修理厂客户：</div>
            <div class="pull-left integration-gain-r">
                <ul>
                    <li>1. 通知博世授权经销商，每月向易加网提供修理厂客户的系统采购数据</li>
                    <li>2. 参加产品促销</li>
                    <li>3. 参加易加网线上活动（签到，抽奖等）</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="solution-item container themecolor" v-if="id == 5">
        <h1 class="solution-title themecolor">秒杀/抢购失效</h1>
        <p>同时抢购这款商品的客户非常多，商品短时间就会被抢光，就会导致抢购失败。最终以秒杀价支付成功做为判断标准。如果秒杀/抢购成功时订单显示有货，过一会订单显示缺货/无货是由于同一时间下单客户较多，导致系统没有及时更新库存状态。如果系统问题导致缺货，我们会尽快的补货，并第一时间通知到您。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 6">
        <h1 class="solution-title themecolor">积分/消费异常</h1>
        <p>请您妥善保管好您的用户名和密码，切勿将其转让或出借给其他人使用。如您发现账号遭盗用，应立即拨打易加网客户服务热线。如因您本人保管疏忽或黑客窃取账号及密码而造成的任何损失，本网站不承担任何责任。任何人不得盗用他人账号及密码，发现此类违法行为，本网站将依法处理，其后果自行承担。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 7">
        <h1 class="solution-title themecolor">信息泄露</h1>
        <p>本网站承诺不对外公开或向第三方提供您的注册资料及使用网站服务时提供的非公开内容（公安机关要求协助调查等特殊情况除外）。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 8">
        <h1 class="solution-title themecolor">促销活动查询</h1>
        <p>您可以在产品展示界面的“促销专区”里查看我司的最新活动。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 9">
        <h1 class="solution-title themecolor">取消订单</h1>
        <p>您可以直接点击“我的订单”查看详情，对于没有发货的商品，每个订单行后面有‘取消订购’按钮，可以点选该按钮进行取消。如货物已经打包好等待发货，则无法取消。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 10">
        <h1 class="solution-title themecolor">修改订单</h1>
        <p>易加网暂不支持客户下单后仍可自助修改订单的情况。但在货物打包好之前，客户仍可联系客服修改订单。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 11">
        <h1 class="solution-title themecolor">礼品到货时间</h1>
        <p>成功兑换礼品并订单生成后，易加网礼品配送中心将按贵公司在系统中的送货地址直接配送，确认您的订单配送时间，一般按您指定的时间范围进行配送，或按与您协商的时间范围内配送。</p>
        <br>
        <p>礼品兑换成功后，易加网礼品配送中心会在1-2个工作日内为您安排所兑换礼品的包装。包装完成后，只需要以下的时间，礼品就能送到您的手中：</p>
        <div class="row">
            <div class="col-75 has-border">上海、浙江、江苏</div>
            <div class="col-25 has-border">1-2个工作日</div>
        </div>
        <div class="row">
            <div class="col-75 has-border">安徽、山东、北京、广东</div>
            <div class="col-25 has-border">2-3个工作日</div>
        </div>
        <div class="row">
            <div class="col-75 has-border">湖南、湖北、河北、福建、江西、河南、天津、山西、海南、辽宁、黑龙江、广西、四川、重庆、云南</div>
            <div class="col-25 has-border">
                <div style="display:table;width:100%;height:100%;">
                    <span style="display:table-cell;vertical-align:middle;">3-5个工作日</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-75 has-border">吉林、甘肃、内蒙古、青海、新疆</div>
            <div class="col-25 has-border">5-7个工作日</div>
        </div>
    </div>

    <div class="solution-item container themecolor" v-if="id == 12">
        <h1 class="solution-title themecolor">物流状态查询</h1>
        <p>点选”我的订单——查看详情“，点击订单下方的“查看物流”按钮，便可查看到物流状态。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 13">
        <h1 class="solution-title themecolor">订单拆分</h1>
        <p>订单拆分通常是因为您所兑换的商品部分满足需求，系统默认有货先发。如有疑问，您可以联系客服为您解答。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 14">
        <h1 class="solution-title themecolor">订单状态查询</h1>
        <p>点击页面下方“我的“，进入新页面后点击”我的订单“，即可查看全部订单。同时，用户也可单独查询待发货订单，已发货订单和已完成订单。订单状态若一直没有变化，可能是由于快递暂时未录入信息导致，若长时间没有更新，请直接联系客服帮您处理。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 15">
        <h1 class="solution-title themecolor">订单异常</h1>
        <p>易加网默认配送完成后会自动显示“货物送达”，如订单未收到货/出现异常，请联系客服处理。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 16">
        <h1 class="solution-title themecolor">拒收订单</h1>
        <p>除货物质量问题或者破损，易加网不支持拒收订单。无故拒收订单，积分不会被退回账户。如果出现如质量或者破损等问题，请在拒收的同时拍照留证，联系客服退回积分。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 17">
        <h1 class="solution-title themecolor">申请退换货</h1>
        <p>易加网暂不支持客户自助申请退换货的情况。若货物存在质量等不可抗原因，请联系客服处理。</p>
    </div>

    <div class="solution-item container themecolor" v-if="id == 18">
        <h1 class="solution-title themecolor">操作须知</h1>
        <p>请在成功登录易加网后首页面的最下方，点击“用户手册”链接，便可直接下载易加网相关使用手册，或致电易加网客户服务热线400-000-5109。</p>
    </div>
</div>
</div>
</template>

<script>
import Header from '@/components/header'
export default {
  components: {
    Header
  },
  data () {
    return {
      id: 1
    }
  },
  created () {
    this.id = this.$route.query.id || 1
  },
  methods: {

  }
}
</script>

<style scoped lang="less">

</style>
